import lodash from "lodash";
import moment from "moment";
import i18n from "../../../../i18n";
import { has } from "../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forCompanyOfficer" })) {
                result = ["Draft", "Plan"].includes(record.refStatus?.key) || result;
            }
            if (has({ menuContext, key: "forCompany" })) {
                result = ["Wait"].includes(record.refStatus?.key) || result;
            }
            return result;
        },
        canSendWait: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forCompanyOfficer" })) {
                result = ["Draft"].includes(record.refStatus?.key) || result;
            }
            return result;
        },
        canSendPlan: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forCompany" })) {
                result = ["Wait"].includes(record.refStatus?.key) || result;
            }
            return result;
        },
        canNoPlan: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forCompanyOfficer" })) {
                if (["Wait", "Plan"].includes(record.refStatus?.key) && record.refCompanyDocRejectReview?.key !== "Efficient") {
                    result = moment().isSameOrAfter(record.dueDatetime) || result;
                }
            }
            return result;
        },
        canDownloadInvestigationForm: ({ record }) => {
            let result = false;
            if (record.refCompanyDocRejectType?.key === "1") {
                result = true;
            }
            return result;
        },
        canDownloadRejectForm: ({ record }) => {
            let result = false;
            if (record.refCompanyDocRejectType?.key === "2") {
                result = true;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["receiveDatetime", "refCompany", "problem", "dueDatetime", "remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if ([undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["microProblem"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => !!modelRef.isProblemMicro,
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if ([undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["chemiProblem"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => !!modelRef.isProblemChemi,
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if ([undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["physicProblem"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => !!modelRef.isProblemPhysic,
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if ([undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["productName", "productDesc"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly, routerPrefix } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if ([undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        if (routerPrefix.includes("investigation")) {
                            if (!modelRef.refCompanyCert) {
                                enabled = !viewOnly || enabled;
                            }
                        } else if (routerPrefix.includes("follow-up")) {
                            enabled = !viewOnly || enabled;
                        }
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["isProblemMicro", "isProblemChemi", "isProblemPhysic"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly, routerPrefix } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if ([undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        if (routerPrefix.includes("investigation")) {
                            enabled = !viewOnly || enabled;
                        }
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["isAnalysisMicro", "isAnalysisChemi", "isAnalysisPhysic"].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { routerPrefix } = props;
                return routerPrefix.includes("follow-up");
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refCompanyCert"].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { routerPrefix } = props;
                return routerPrefix.includes("investigation");
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if ([undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        enabled = (!viewOnly && modelRef.refCompany?.id) || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refCountry"].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { routerPrefix } = props;
                return routerPrefix.includes("investigation");
            }
        },
        {
            check: ({ field }) => {
                return ["refCompany.refStatus"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    enabled = (!viewOnly && modelRef.refCompany?.id) || enabled;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["destinationCountryDatetime", "refCode"].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { routerPrefix } = props;
                return routerPrefix.includes("investigation");
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if ([undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field, modelRef }) => {
                return (
                    field?.key.startsWith("companyDocRejectProducts.0") &&
                    field?.key.endsWith("refSamplingProduct") &&
                    modelRef.companyDocRejectProducts?.[0]?.isDelete !== true
                );
            },
            visibleField: ({ props, modelRef }) => {
                const { routerPrefix } = props;
                let visible = false;
                if (routerPrefix.includes("follow-up")) {
                    visible = true || visible;
                } else if (routerPrefix.includes("company-doc-reject")) {
                    if (["2"].includes(modelRef.refCompanyDocRejectType?.key)) {
                        visible = true || visible;
                    }
                }
                return visible;
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if ([undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        enabled = (!viewOnly && modelRef.refCompany?.id) || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "companyDocRejectProducts.0.refSamplingProduct.refSamplingRequest.samplingCollectDate",
                    "companyDocRejectProducts.0.refSamplingProduct.refSamplingRequest.refSamplingDepartment.nameTh",
                    "downloadRejectForm"
                ].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { routerPrefix } = props;
                return routerPrefix.includes("follow-up");
            }
        },
        {
            check: ({ field }) => {
                return ["refCountry", "exportName", "exportAddress"].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { routerPrefix } = props;
                return routerPrefix.includes("investigation");
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if ([undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        enabled = (!viewOnly && !modelRef.refCompanyCert?.id) || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["noPlanRemark"].includes(field?.key);
            },
            visibleField: ({ initialModel }) => {
                return ["No plan"].includes(initialModel.refStatus?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["planDatetime", "planRemark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if (["Plan"].includes(initialModel.refStatus?.key)) {
                        enabled = false || enabled;
                    }
                }
                if (has({ menuContext, key: "forCompany" })) {
                    enabled = !viewOnly || enabled;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refCompanyDocRejectReview", "reviewDatetime", "reviewRemark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if (["Plan"].includes(initialModel.refStatus?.key)) {
                        if (!initialModel.refCompanyDocRejectReview) {
                            enabled = !viewOnly || enabled;
                        }
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyDocReject"].includes(sectionKey);
            },
            visibleSection: ({ props }) => {
                const { routerPrefix } = props;
                let visible = false;
                if (routerPrefix.includes("investigation") || routerPrefix.includes("follow-up")) {
                    visible = true || visible;
                }
                return visible;
            },
            cardProp: ({ props, modelRef }) => {
                const { routerPrefix } = props;
                let title = undefined;
                if (routerPrefix.includes("company-doc-reject")) {
                    if (modelRef.refCompanyDocRejectType?.key === "1") {
                        title = i18n.global.t(`views.company.investigation.title`);
                    } else if (modelRef.refCompanyDocRejectType?.key === "2") {
                        title = i18n.global.t(`views.company.follow-up-reject.title`);
                    }
                }
                return { title };
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyDocRejectProduct"].includes(sectionKey);
            },
            visibleSection: ({ props, modelRef, initialModel }) => {
                const { routerPrefix } = props;
                let visible = false;
                if (routerPrefix.includes("investigation")) {
                    visible = modelRef.refCompany || visible;
                } else if (routerPrefix.includes("follow-up")) {
                    const companyDocRejectProduct = modelRef.companyDocRejectProducts.find(d => d.isDelete !== true);
                    visible = companyDocRejectProduct?.refSamplingProduct || visible;
                } else if (routerPrefix.includes("company-doc-reject")) {
                    if (initialModel.reviewSpecialDueDatetime && modelRef.refCompanyDocRejectType?.key === "1") {
                        visible = true || visible;
                    }
                }
                return visible;
            },
            componentProp: ({ props, initialModel }) => {
                const { menuContext, routerPrefix, viewOnly } = props;
                let menuContextClone = lodash.cloneDeep(menuContext);
                let visibleSamplingProduct = false;
                let visibleRowAction = false;
                let enabledSamplingCondition = false;
                let enabledIsSuspendedSampling = false;
                let enabledIsSuspendedHc = false;
                if (routerPrefix.includes("investigation")) {
                    visibleRowAction = true;
                    visibleSamplingProduct = true;
                    if (has({ menuContext, key: "forCompanyOfficer" })) {
                        enabledSamplingCondition = !viewOnly || enabledSamplingCondition;
                        enabledIsSuspendedSampling = !viewOnly || enabledIsSuspendedSampling;
                        enabledIsSuspendedHc = !viewOnly || enabledIsSuspendedHc;
                    }
                } else if (routerPrefix.includes("follow-up")) {
                    visibleSamplingProduct = true;
                    if (has({ menuContext, key: "forCompanyOfficer" })) {
                        enabledSamplingCondition = !viewOnly || enabledSamplingCondition;
                        enabledIsSuspendedSampling = !viewOnly || enabledIsSuspendedSampling;
                        enabledIsSuspendedHc = !viewOnly || enabledIsSuspendedHc;
                    }
                } else if (routerPrefix.includes("company-doc-reject")) {
                    if (initialModel.refCompanyDocRejectType?.key === "1") {
                        visibleRowAction = true;
                    }
                    visibleSamplingProduct = true;
                    menuContextClone.attribute = ["canView"];
                }
                return {
                    menuContext: menuContextClone,
                    visibleSamplingProduct,
                    visibleRowAction,
                    disabledSamplingCondition: !enabledSamplingCondition,
                    disabledIsSuspendedSampling: !enabledIsSuspendedSampling,
                    disabledIsSuspendedHc: !enabledIsSuspendedHc
                };
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["Attachment"].includes(sectionKey);
            },
            visibleSection: ({ props, initialModel }) => {
                const { menuContext, routerPrefix } = props;
                let visible = false;
                if (routerPrefix.includes("investigation") || routerPrefix.includes("follow-up")) {
                    if (has({ menuContext, key: "forCompanyOfficer" })) {
                        if (!["Draft", "Wait"].includes(initialModel.refStatus?.key)) {
                            visible = true || visible;
                        }
                    }
                }
                if (routerPrefix.includes("company-doc-reject")) {
                    visible = true || visible;
                }
                return visible;
            },
            componentProp: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let menuContextClone = lodash.cloneDeep(menuContext);
                let enabled = false;
                if (has({ menuContext, key: "forCompany" })) {
                    if (["Wait"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                        if (enabled) {
                            menuContextClone.attribute = ["canCreate", "canView", "canEdit", "canDelete"];
                        }
                    }
                }
                return {
                    menuContext: menuContextClone,
                    viewOnly: !enabled
                };
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["ConsiderPlan"].includes(sectionKey);
            },
            visibleSection: ({ props, initialModel }) => {
                const { menuContext, routerPrefix } = props;
                let visible = false;
                if (routerPrefix.includes("investigation") || routerPrefix.includes("follow-up")) {
                    if (has({ menuContext, key: "forCompanyOfficer" })) {
                        if (["Plan"].includes(initialModel.refStatus?.key) || initialModel.refCompanyDocRejectReview) {
                            visible = true || visible;
                        }
                    }
                } else if (routerPrefix.includes("company-doc-reject")) {
                    if (has({ menuContext, key: "forCompany" })) {
                        if (initialModel.refCompanyDocRejectReview) {
                            visible = true || visible;
                        }
                    }
                }
                return visible;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["Special"].includes(sectionKey);
            },
            visibleSection: ({ props, modelRef, initialModel }) => {
                const { menuContext, routerPrefix } = props;
                let visible = false;
                if (routerPrefix.includes("investigation") || routerPrefix.includes("follow-up")) {
                    if (has({ menuContext, key: "forCompanyOfficer" })) {
                        if (["Plan"].includes(initialModel.refStatus?.key)) {
                            if (["Efficient"].includes(modelRef.refCompanyDocRejectReview?.key)) {
                                visible = true || visible;
                            }
                        }
                    }
                } else if (routerPrefix.includes("company-doc-reject")) {
                    if (has({ menuContext, key: "forCompany" })) {
                        if (initialModel.reviewSpecialDueDatetime) {
                            visible = true || visible;
                        }
                    }
                }
                return visible;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["FollowupRejectLab"].includes(sectionKey);
            },
            visibleSection: ({ props, modelRef, initialModel }) => {
                const { menuContext, routerPrefix } = props;
                let visible = false;
                if (routerPrefix.includes("follow-up")) {
                    if (has({ menuContext, key: "forCompanyOfficer" })) {
                        if (["Plan"].includes(initialModel.refStatus?.key)) {
                            if (["Efficient"].includes(modelRef.refCompanyDocRejectReview?.key)) {
                                visible = true || visible;
                            }
                        }
                    }
                } else if (routerPrefix.includes("company-doc-reject")) {
                    if (has({ menuContext, key: "forCompany" })) {
                        if (initialModel.reviewSpecialDueDatetime && modelRef.refCompanyDocRejectType?.key === "2") {
                            visible = true || visible;
                        }
                    }
                }
                return visible;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["SamplingProductList"].includes(sectionKey);
            },
            visibleSection: ({ props, modelRef, initialModel }) => {
                const { menuContext, routerPrefix } = props;
                let visible = false;
                if (routerPrefix.includes("investigation")) {
                    if (has({ menuContext, key: "forCompanyOfficer" })) {
                        if (["Plan"].includes(initialModel.refStatus?.key)) {
                            if (["Efficient"].includes(modelRef.refCompanyDocRejectReview?.key)) {
                                if (initialModel.reviewSpecialDueDatetime) {
                                    visible = true || visible;
                                }
                            }
                        }
                    }
                } else if (routerPrefix.includes("follow-up")) {
                    if (has({ menuContext, key: "forCompanyOfficer" })) {
                        if (["Plan"].includes(initialModel.refStatus?.key)) {
                            if (["Efficient"].includes(modelRef.refCompanyDocRejectReview?.key)) {
                                if (initialModel.reviewSpecialDueDatetime) {
                                    visible = true || visible;
                                }
                            }
                        }
                    }
                }
                return visible;
            }
        }
    ];
};
